/**
 * 描述： 新手礼包弹窗
 * 作者： WangRui
 * 时间： 2020年10月29日 11:50:31
 * */
import React, { PureComponent } from 'react';
import { withRouter } from '../WithRouterHOC';
import { Button, Modal } from 'antd';
import { _hide_coupon_modal, _show_login_modal } from '../../store/Action';
import Util from '../../script/util';
import Scrollbar from 'react-scrollbars-custom';
import './newbiePack.scss';

class NewbiePack extends PureComponent {
  // 关闭弹窗
  // bool 是否是登录状态
  handleClose = (bool = false) => {
    Util.setCookie('firstIn', true);
    _hide_coupon_modal(bool);
  };
  // 点击注册
  handleConfirm = () => {
    const { userInfo } = this.props.base;
    if (!userInfo) {
      _show_login_modal();
      this.handleClose(false);
    } else {
      this.handleClose(true);
    }
  };

  render() {
    const { coupon_visible, coupon_data } = this.props.base;

    return (
      <Modal
        title={null}
        open={coupon_visible}
        wrapClassName="transparent-body has-top-border newbie-pick-wrap"
        footer={null}
        closable={!this.props.base.userInfo}
        closeIcon={null}
        onCancel={() => this.handleClose()}
        maskClosable={false}
        centered={true}
      >
        <div className="newbie-pick-bg">
          <ul className="newbie-pick-content">
            <Scrollbar className="newbie-scroll-bar">
              {coupon_data && coupon_data.length
                ? coupon_data.map((item) => (
                    <li key={item.id} className="newbie-item">
                      <div className="prize-img">
                        <img
                          src={Util.transImgUrl(item.cover, '100x100')}
                          alt={item.name}
                        />
                        <span className="number">x{item.number}</span>
                      </div>
                      <div className="desc">
                        <p className="name">{item.remark}</p>
                      </div>
                    </li>
                  ))
                : null}
            </Scrollbar>
          </ul>

          <div className="footer">
            <Button className="btn-confirm" onClick={this.handleConfirm} />
          </div>
        </div>
      </Modal>
    );
  }
}

export default withRouter(NewbiePack, { withRef: true });
